<template>
  <div
    v-if="value"
    class="case-container"
  >
    <div
      class="case-close"
      @click="close"
    >
      <img src="/static/img/close.svg">
    </div>
    <div class="case-dialog">
      <h1 class="title">
        {{ content.title }}
      </h1>
      <div class="intro">
        <ul>
          <li>【法院】 {{ content.court }}</li>
          <li>【案号】 {{ content.no }}</li>
        </ul>
      </div>
      <div
        class="details"
        v-html="content.content"
      />
    </div>
    <div
      class="mask"
      @click="close"
    />
  </div>
</template>
<style lang="stylus">
.case-container
  .case-close
    position fixed
    width 64px
    height 64px
    top 12%
    right 16%
    z-index 12000
    img
      width 100%
  .case-dialog
    position fixed
    left 50%
    transform translateX(-50%)
    width 75%
    top 10%
    bottom 10%
    // bottom calc(20% - 100px)
    margin 0 auto
    background #fff
    border-radius 6px
    z-index 11000
    padding 30px 100px 60px
    overflow-y scroll
    -webkit-overflow-scrolling touch
    h1.title
      font-size 0.32rem
      font-weight bold
      text-align center
      padding 0.3rem 0
    .intro
      background #ecedf1
      padding 0.15rem
      font-size 0.22rem
      color #808080
      margin-bottom 0.2rem
      border-radius 0.08rem
      line-height 1.8
    .details
      font-size 0.28rem
      line-height 1.8
      p
        margin-bottom 0.25rem
        strong
          font-size 0.28rem
  .mask
    position fixed
    left 0
    right 0
    top 0
    bottom 0
    background rgba(0, 0, 0, 0.5)
    z-index 10000
</style>

<script>
export default {
  props: ['value', 'content'],
  methods: {
    close () {
      this.$emit('input', false)
    }
  }
}
</script>
